import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import { createVNode, reactive, ref } from 'vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { message, Modal, notification } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import {
  delete_card_record,
  direct_delete_order_record,
  direct_delete_set_record,
} from '@/api/mjstore-model';

import bus from '@/utils/bus';

const event_bus = bus;
export const event_obj = mitt();
export const btn_list = [
  {
    name: '作废',
    clazz: 'danger',
    is_show: (record: any) => {
      return !record.is_delete;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      Modal.confirm({
        title: '提示',
        content: `该项目所在套餐中的全部项目将同步作废，确定作废后请重新购买套餐`,
        onOk() {
          direct_delete_set_record({
            set_record_id: record.id,
            org_id: current_org?.id,
          }).then((res: any) => {
            if (res.show_message) {
              Modal.warning({
                title: res.show_message,
              });
            } else {
              message.success('作废成功');
              event_obj.emit('refresh');
              event_bus.emit('refresh_custom_info', record.customer_id);
            }
          });
        },
        onCancel() {},
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};
export const head_btn_list = [
  {
    name: '新建',
    clazz: 'primary',
    icon: 'plus-outlined',
    cb: (data: any) => {
      const modifyModal: any = reactive({
        visible: false,
        component: 'Setrecordmodel',
        obj: {
          customer_id: data.customer_id,
          require_info_id: data.require_info_id,
          disabled: true,
        },
      });

      modifyModal.visible = true;
      modifyModal.ok = () => {
        event_obj.emit('refresh');
      };
      modifyModal.cancel = () => {};
      modalBox(modifyModal);
    },
  },
];
